import { rem } from 'polished';
import styled, { css } from 'styled-components';
import { Button, ButtonStyledStyles } from '../_helpers/form/Button';
import IconLazy from '../_helpers/Icon/IconLazy';

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  margin: ${rem(30)} 0;
  ${({ theme }) => theme.media('xs')} {
    align-items: center;
  }
  ${({ theme }) => theme.media('sm')} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const NextButton = styled(Button)`
  ${ButtonStyledStyles};
  &.lg {
    padding-right: ${rem(20)};
    padding-left: ${rem(20)};
  }
`;

export const PriceCart = styled.div`
  font-size: ${rem(24)};
  font-weight: 700;
`;

export const TotalPriceCart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  background: ${({ theme }) => theme.color.white};
  margin: ${rem(2)} ${({ theme }) => rem(-theme.grid.padding / 2)} ${rem(30)};
  ${({ theme }) => theme.media('sm')} {
    background: transparent;
    padding-bottom: 0;
    margin-bottom: 0;
  }
`;

export const TotalPriceText = styled.div`
  font-size: ${rem(14)};
  margin-right: ${rem(10)};
  ${({ theme }) => theme.media('sm')} {
    margin-right: ${rem(20)};
  }
`;

export const BackIcon = styled(IconLazy)`
  ${({ theme }) => theme.size(12)};
  margin-right: ${rem(16)};
  transform: translateY(${rem(-2)}) rotate(90deg);
`;

export const BackLinkStyles = css`
  background: transparent;
  margin-top: ${rem(20)};
  &:not(:disabled):hover,
  &:focus {
    background: ${({ theme }) => theme.color.white};
    border-color: ${({ theme }) => theme.color.white};
  }
  ${({ theme }) => theme.media('sm')} {
    order: -1;
    margin-top: 0;
  }
`;
